import { render, staticRenderFns } from "./GraficosGrid.vue?vue&type=template&id=2b52da70&scoped=true&"
import script from "./GraficosGrid.vue?vue&type=script&lang=ts&"
export * from "./GraficosGrid.vue?vue&type=script&lang=ts&"
import style0 from "./GraficosGrid.vue?vue&type=style&index=0&id=2b52da70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b52da70",
  null
  
)

export default component.exports